import type { Language, MeDto } from '@posilka/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

export const meKey = ['me'] as const;

export const useMe = () =>
  useQuery({ queryKey: meKey, queryFn: () => api<MeDto>('/me'), staleTime: 60_000 });

export const useUpdateMe = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { firstName?: string; language?: Language }) =>
      api<MeDto>('/me', { method: 'PATCH', body }),
    onSuccess: (me) => qc.setQueryData(meKey, me),
  });
};
